import decoder from 'he';

export class HtmlCharacterEntityValueConverter {
  toView(value) {
    if (!value) return value;
    return decoder.decode(value);
  }
}
